import { styled } from '@mui/material';
import { ReactComponent as Logo } from '../../assets/images/logo.svg';

export const StyledLogo = styled(Logo)(() => ({
  cursor: 'pointer',
  margin: '0px',
  width: '133px',
}));
